import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router';

import nds from '@nerdwallet/base-styles/classes';
import { Legal, Type } from '@nerdwallet/currency';

import { stringSelectSpec } from '../../lib/editing-configs';
import { isInBuilder } from '../../lib/helpers';

export const VISIBILITY_CONDITIONS = {
  ALWAYS_SHOW: {
    label: 'Always show',
    value: 'alwaysShow',
  },
  HIDE_ON_MOBILE: {
    label: 'Hide on mobile',
    value: 'hideOnMobile',
  },
  HIDE_ON_DESKTOP: {
    label: 'Hide on desktop',
    value: 'hideOnDesktop',
  },
};

const ScreenSizeConditional = ({ children, history, visibility }) => {
  const isBuilder = isInBuilder(_.get(history, 'location.pathname'));
  let classes = '';

  // Generate visibility classes.
  if (!isBuilder) {
    if (visibility === VISIBILITY_CONDITIONS.HIDE_ON_MOBILE.value) {
      classes = nds('display-none', 'display-initial--wide');
    } else if (visibility === VISIBILITY_CONDITIONS.HIDE_ON_DESKTOP.value) {
      classes = nds('display-none--wide');
    }
  }

  const builderNote = isBuilder ? (
    <Legal>
      <Type inline bold>
        Note:
      </Type>{' '}
      This component is always visible in the editor, however it will be
      displayed to consumers based on the following screen size criteria:{' '}
      <code>{visibility}</code>
    </Legal>
  ) : null;

  return (
    <div className={classes}>
      {builderNote}
      {children}
    </div>
  );
};

ScreenSizeConditional.propTypes = {
  children: PropTypes.node,
  history: PropTypes.object,
  visibility: PropTypes.oneOf(
    _.map(VISIBILITY_CONDITIONS, ({ value }) => value)
  ),
};

ScreenSizeConditional.defaultProps = {
  children: [],
  visibility: VISIBILITY_CONDITIONS.ALWAYS_SHOW.value,
};

ScreenSizeConditional.description =
  'Use the "Insert Child" functionality in the "Build" tab to add components that will display only when the screen size criteria is met.';

ScreenSizeConditional.getEditingConfig = () => [
  stringSelectSpec(
    'visibility',
    'Visibility',
    Object.values(VISIBILITY_CONDITIONS),
    {
      help: 'Select when you would like to show/hide the children of this component.',
    }
  ),
];

ScreenSizeConditional.isContainer = true;

export default withRouter(ScreenSizeConditional);
